<template>
  <page>
    <v-card>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-card-title>
        <div class="headline">Engine Model Listing</div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="items" :search="search" :rows-per-page-items="itemsPerPage" :pagination.sync="pagination" item-key="vesEngMod" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.vesEngMod }}</td>
          <td class="text-xs-left">{{ formatTextLength(props.item.vesEngModDesc) }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview(props.item.vesEngMod)" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-btn color="primary" dark class="mb-2" @click="doNew">
      New Engine Model
      <v-icon right>mdi-plus</v-icon>
    </v-btn>
    <v-dialog v-model="engModelDialog" width="800px" lazy persistent v-if="checkAccess(['vesselReview'])">
      <VesEngModelDialog :vesEngModelForm="vesEngModelForm" @close="doClose" :newEngModel="newEngModel"></VesEngModelDialog>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Vessel Engine Model? ({{deleteVesEngModel}})
    </confirm>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import VesEngModelDialog from './vesEngModelDialog'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      headers: [
        { text: 'Engine Model', value: 'vesEngMod' },
        { text: 'Engine Model Description', value: 'vesEngModDesc' },
        TableConst.tableActionHeader
      ],
      engModelDialog: undefined,
      newEngModel: undefined,
      loading: false,
      vesEngModelForm: {
        vesEngMod: undefined,
        vesEngModelDesc: undefined
      },
      promptRemove: false,
      selectedVesEngModel: undefined,
      deleteVesEngModel: ''
    }
  },
  created() {
    this.doInit(null)
  },
  methods: {
    async doInit(options) {
      this.loading = true
      const apiURL = this.vesMenu.getVslEngMods
      if (apiURL) {
        try {
          const result = await this.$http.get(apiURL)
          if (result) {
            const { data } = result.data
            this.$store.commit('VESSEL_ENGMODLIST', data)
            this.items = []
            data.map((vslEngMod) => {
              const convertVslEngMod = {
                vesEngMod: vslEngMod.vesEngMod,
                vesEngModDesc: vslEngMod.vesEngModDesc
              }
              this.items.push(convertVslEngMod)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
      this.loading = false
    },
    async doReview(vesEngMod) {
      const apiURI = this.vesMenu.getVslEngMod
      const expand = {
        vesEngMod
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.vesEngModelForm.vesEngMod = data.vesEngMod.vesEngMod
          this.vesEngModelForm.vesEngModDesc = data.vesEngMod.vesEngModDesc
        }
        this.engModelDialog = true
      }
    },
    doNew() {
      this.$validator.reset()
      this.engModelDialog = true
      this.newEngModel = true
    },
    doClose() {
      this.engModelDialog = false
      this.newEngModel = false
      this.$validator.reset()
      this.doInit(null)
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedVesEngModel = data
        this.deleteVesEngModel = data.vesEngMod + ' - ' + data.vesEngModDesc
      }
    },
    async doRemove() {
      const apiURI = this.vesMenu.deleteVslEngMod
      if (apiURI) {
        const expand = this.selectedVesEngModel
        this.$http.post(apiURI, expand).then(result => {
          const data = result.data
          this.notify(data)
          this.doInit(null)
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    vesMenu() {
      return this.$store.state.vessel.menu
    }
  },
  components: {
    VesEngModelDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
